import './api'
import './colors'
import './components'
import './gtm'
import './sweetalert2'
import './compositionApi'
import './moment'
import './vueMeta'
import './vueCookies'
import './profileObj'
import './sentry'
import vuetify from './vuetify'
import './veevalidate'
import './vuelidate'
// import './pretendard'

export default {
  vuetify,
}
